export enum EnumSelectionType {
  Checkbox,
  Combobox,
  Radio,
  Dropdown,
}
